import { ChevronRight } from 'lucide-react';
import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '../../lib/utils';

export interface BreadcrumbItem {
  label: ReactNode;
  to?: string;
  icon?: ReactNode;
}

/** "Releases › v2.5.2" trail: linked ancestors in white, current in muted. */
export function Breadcrumb({
  items,
  className,
}: {
  items: BreadcrumbItem[];
  className?: string;
}) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={cn(
        'flex min-w-0 flex-wrap items-center gap-3 text-sm font-medium',
        className,
      )}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const content = (
          <span className="flex min-w-0 items-center gap-2.5 [&>svg]:size-4 [&>svg]:shrink-0">
            {item.icon}
            <span className="truncate">{item.label}</span>
          </span>
        );

        return (
          <Fragment key={index}>
            {index > 0 ? (
              <ChevronRight
                aria-hidden="true"
                className="size-4 shrink-0 text-seeker-400"
              />
            ) : null}
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="text-white transition-colors hover:text-seeker-300"
              >
                {content}
              </Link>
            ) : (
              <span
                aria-current={isLast ? 'page' : undefined}
                className={isLast ? 'text-seeker-400' : 'text-white'}
              >
                {content}
              </span>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
